{
  "appVersion": "2026-11-04-develop-6696-7cdef0d",
  "forceUpdate": false
}
